import { render, staticRenderFns } from "./OldGoldStatement.vue?vue&type=template&id=363f6756&scoped=true&"
import script from "./OldGoldStatement.vue?vue&type=script&lang=js&"
export * from "./OldGoldStatement.vue?vue&type=script&lang=js&"
import style0 from "./OldGoldStatement.vue?vue&type=style&index=0&id=363f6756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f6756",
  null
  
)

export default component.exports